'use client';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { bannerBottomInfoTitle, contacts } from '@/_config';
const cardPt = {
    root:{ className:'h-full'},
    body: { className: 'h-full flex flex-column justify-content-center align-items-center' },
    content: { className: ' text-white h-full flex flex-column justify-content-center align-items-center border-1 p-4 border-300 border-round-sm w-full' },
    title: { className: 'text-xl' }
}

export const ProductAds =() => {
    return (
        <Card pt={cardPt}>
                <i className='pi pi-bell text-8xl'/>
                <div className='font-bold'> More Smart Product Commimg Soon</div>
                <Divider className='w-full' />
                <div className='font-italic'>
                    {bannerBottomInfoTitle}

                </div>
                <div className='flex flex-column gap-3 mt-3 justify-content-center align-items-center'>
                <div className='font-bold'> {contacts?.enquiry}</div>
                <div className='font-bold'>OR</div>
                <div>Write Us</div>
                <div className='font-bold'>{contacts?.emailSupport}</div>
                </div>
        </Card>

    )
}